import { useCallback } from 'react';

import { useLoi } from '../../../../hooks/useLoi';
import { useT } from '../../../../i18n';
import { maLoi, type ApiError } from '../../../../lib/errors';

/**
 * Câu lỗi cho người đọc — thay `moTaLoi` (native `loi.ts`). Mã chung đi qua catalog (`useLoi`), mã nghiệp vụ giữ
 * `detail` nguyên văn của audit-service: câu từ chối của module nói ĐÚNG quyền còn thiếu ("Sửa ở mục Cấu hình nhật ký"),
 * nên `403` ghép lý do ấy vào sau câu chung thay vì nuốt mất.
 */
export function useMoTaLoi(): (err: unknown) => string {
  const { t } = useT();
  const dichLoi = useLoi();
  return useCallback(
    (err: unknown) => {
      const ma = maLoi(err);
      const cau = (err as ApiError | undefined)?.message?.trim();
      if ((ma === 'PERMISSION_DENIED' || ma === 'FORBIDDEN') && cau) return `${t('loi.khongCoQuyen')} ${cau}`;
      return dichLoi(err);
    },
    [t, dichLoi],
  );
}
